import { ElementRef } from "@angular/core";

export class VerifyService {
  public static focusElement(selector: string, elementRef?: ElementRef) {
    const nativeElement = elementRef && elementRef.nativeElement || document;
    let target = nativeElement.ownerDocument.getElementById(selector);
    if (target) {
      if (target.tagName !== 'INPUT') {
        const input = target.getElementsByTagName('input');
        if (input.length) {
          target = input[0];
        }
      }
      target.focus();
    }
  }
}